/* eslint-disable import/prefer-default-export */
import env from 'utils/env';
import requestJson from './requestJson';

export const getBoxState = () => {
  const headers = {
    Accept: '*',
    'Content-Type': 'application/json',
  };
  const requestUrl = `${env.box}/self/box-state`;
  return requestJson(requestUrl, 'GET', headers);
};
